import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum BobcardEventTypes {
    "call" = "2490b36b-41f7-4739-80a8-b54a078e5cd3",
    "applicationsInitiated" = "ea5ce140-c1c3-4363-9b73-cb1ba6b6397a",
    /** @deprecated Use `applicationsInitiated`. */
    "enquiry" = "ea5ce140-c1c3-4363-9b73-cb1ba6b6397a",
}

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const BOBCARD__EVENT__APPLICATIONS_INITIATED__DISPOSITION__COLUMN_ID = "e8086c6e-2987-49b0-b160-df04e003881e" as Uuid;

export const BOBCARD__EVENT__CALL__DISPOSITION__COLUMN_ID = "f0de2ec8-f672-4b49-a65f-9197f4723a47" as Uuid;

export const BOBCARD__CALL__SCHEDULE__FORM__ID = "02bc87d4-c5f8-412f-baa8-5de10b1beb48" as Uuid;

export const BOBCARD__CALL__LOG__FORM__ID = "63a9998c-297e-40f7-ba33-ed8f5fe6ea5c" as Uuid;

export const BOBCARD__CALL__EDIT__FORM__ID = "6d9ecfa1-9b36-4f88-97e4-a4669b18c121" as Uuid;

export const BOBCARD__EVENT__CALLS__CALL_TYPE__COLUMN_ID = "3671d21b-bf87-40eb-aca4-a7c2b3c4df86" as Uuid;

export const BOBCARD__EVENT__CALLS__STATUS__COLUMN_ID = "e1ebb6b0-8281-4bf6-beae-bb7fd369da4f" as Uuid;

export const BOBCARD__EVENT__CALLS__CALL_DISPOSITION__COLUMN_ID = "f3cc72c6-0cd5-47ff-a6da-c1299473121e" as Uuid;

export const BOBCARD__EVENT__CALLS__LOGGED_CALL_REMARKS__COLUMN_ID = "2ec4e8fa-2f3a-4ee6-9f3e-6a4b5595a284" as Uuid;

export const BOBCARD__EVENT__CALLS__CALL_START_TIME__COLUMN_ID = "767eba44-4231-4af3-98a0-a695dc612c19" as Uuid;

export const BOBCARD__EVENT__CALLS__CALL_END_TIME__COLUMN_ID = "71c062c5-8381-4f9a-9085-319857210718" as Uuid;

export const BOBCARD__EVENT__CALLS__CALL_DURATION__COLUMN_ID = "0b08a7b8-e568-4de3-bf5a-ff6293a8e283" as Uuid;

export const BOBCARD__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID = "19d471fe-14ce-45ae-b96e-da28cc895a68" as Uuid;

export const BOBCARD__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID = "75cc23ae-578f-4869-bb9c-ce864b67a1c0" as Uuid;

export const BOBCARD__EVENT__CALLS__LOGGED_BY__COLUMN_ID = "1bda08ce-02c9-433e-9c49-5dfa4f63d5fb" as Uuid;

export const BOBCARD__EVENT__CALLS__LOGGED_ON__COLUMN_ID = "feab6625-8eb1-4764-9f8b-3fc49720d625" as Uuid;

export const BOBCARD__EVENT__CALLS__CANCELLED_BY__COLUMN_ID = "261703a4-7827-4afd-a495-95be16023af0" as Uuid;

export const BOBCARD__EVENT__CALLS__CANCELLED_ON__COLUMN_ID = "0c41276c-d1d9-4d8a-87f1-9f3fa4ebafc3" as Uuid;

export const BOBCARD__EVENT__CALLS__CANCELLATION_REMARKS__COLUMN_ID = "72984807-fe4f-4d90-88f4-d93b4b428c9a" as Uuid;

export const BOBCARD__EVENT__CALLS__LEAD_OWNER__COLUMN_ID = "eda812b8-d277-4426-b2a3-e62149071e55" as Uuid;

export const BOBCARD__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID = "e8735c26-9046-421b-bfd1-a2b558928fc5" as Uuid;

export const BOBCARD__EVENT__CALLS__UTM_SOURCE__COLUMN_ID = "76c028eb-57fe-45be-981a-0e7e03a5bc33" as Uuid;

export const BOBCARD__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID = "e630aab6-7866-4b13-b935-d3221044dd37" as Uuid;

export const BOBCARD__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID = "e4ce7343-0e6f-417b-ba8a-b68366a2a2d4" as Uuid;

export const BOBCARD__EVENT__CALLS__UTM_TERM__COLUMN_ID = "34200d1b-187b-4651-8a62-83798880c336" as Uuid;

export const BOBCARD__EVENT__CALLS__UTM_CONTENT__COLUMN_ID = "86d9c9f8-5f52-47f8-a375-4003453952a8" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID = "8e0f94ef-0764-4bc4-9535-0286249bb869" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID = "233c3236-3909-405f-9e19-2270481b8fd5" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__DIGITAL_LEAD_STATUS__COLUMN_ID = "251bb111-af30-4bc0-9aba-36559040c031" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID = "88e0e4dc-d2e4-4473-ab99-67eec0bddc89" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID = "ac24b4e3-0b40-40b5-a633-8a67e1c81b5d" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID = "df82050f-89d7-4d3a-97a9-db0de1b143b0" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID = "ab78d98f-4d6d-4c02-ab05-8a11e965cd6d" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID = "0cee61ad-e598-4e2b-a7a1-f2e38ee35dc5" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID = "891cb75e-cfbd-4033-bf2b-d33603c4d838" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__FBCLID__COLUMN_ID = "7449ed75-568f-41e6-b4d0-81de53470f78" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__GCLID__COLUMN_ID = "436c1af4-5c5a-489a-b190-4f112b633286" as Uuid;

export const BOBCARD__EVENT__ENQUIRY__REFERRER__COLUMN_ID = "8e3b0d2f-4c5e-4f9b-a03d-2b3c4d5e6f7a" as Uuid;

export const BOBCARD__EVENT__CALL__FBCLID__COLUMN_ID = "de763ec8-8d42-4504-8514-4f08258d6115" as Uuid;

export const BOBCARD__EVENT__CALL__GCLID__COLUMN_ID = "feea7bfe-78df-4331-91af-d4052ac12d6a" as Uuid;

export enum EventCallType {
    "inbound" = "89e9e6d0-3cf2-40b5-a70f-a2fe18aa0571",
    "outBound" = "984a24bd-5631-4c70-813f-ba225aed98d2",
}

export enum BobcardCallStatusEnum {
    SCHEDULED = "0950b9f2-ae88-4872-96dd-aeeed20ce05b",
    CANCELLED = "4a6eef0d-790c-440e-9c11-f6fa6db12b06",
    LOGGED = "ed622374-ef11-40b5-8324-d41579162ef0",
    ARCHIVE = "5ee4ada1-5e61-4924-826d-56a05876c212",
}

export enum BobcardEventCallDispositionEnum {
    LOGGED,
    SCHEDULED,
    CANCELLED,
}

export const bobcardCallStatuses: Record<
    BobcardCallStatusEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardCallStatusEnum.SCHEDULED]: {
        id: BobcardCallStatusEnum.SCHEDULED as Uuid,
        displayName: "Scheduled",
    },
    [BobcardCallStatusEnum.CANCELLED]: {
        id: BobcardCallStatusEnum.CANCELLED as Uuid,
        displayName: "Cancelled",
    },
    [BobcardCallStatusEnum.LOGGED]: {
        id: BobcardCallStatusEnum.LOGGED as Uuid,
        displayName: "Logged",
    },
    [BobcardCallStatusEnum.ARCHIVE]: {
        id: BobcardCallStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

/** Event-template disposition rows (Logged / Scheduled / Cancelled) for calls. */
export const bobcardEventCallDispositions: Record<
    BobcardEventCallDispositionEnum,
    {
        id: Uuid;
        displayName: string;
    }
> = {
    [BobcardEventCallDispositionEnum.LOGGED]: {
        id: "ab2e9f07-fce9-4899-8119-575aed6f84fe" as Uuid,
        displayName: "Logged",
    },
    [BobcardEventCallDispositionEnum.SCHEDULED]: {
        id: "d409b55a-dcc8-4f28-89c4-b4586df2f6f1" as Uuid,
        displayName: "Scheduled",
    },
    [BobcardEventCallDispositionEnum.CANCELLED]: {
        id: "3f7eaa6b-fff5-4e59-8d04-669e795f7b87" as Uuid,
        displayName: "Cancelled",
    },
};

export const getBobcardCallStatuses = () => Object.values(bobcardCallStatuses);

export const getBobcardEventCallDispositions = () => Object.values(bobcardEventCallDispositions);
